import { tabsAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, } from '@chakra-ui/styled-system';
import { ThemeBorderToken, ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, ThemeRadiusToken, } from '../theme-tokens';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
    tab: {
        color: ThemeColorToken.OnBackground,
        fontFamily: ThemeFontToken.SubHeader,
        fontWeight: 'medium',
        borderRadius: ThemeRadiusToken.XLarge,
        bg: 'none',
        border: ThemeBorderToken.XSmall,
        borderColor: 'transparent',
        whiteSpace: 'nowrap',
        WebkitTapHighlightColor: 'transparent',
    },
    tabWithImage: {
        _disabled: {
            cursor: 'not-allowed',
        },
    },
    tabpanel: {
        p: 0,
    },
});
const sizes = {
    sm: definePartsStyle({
        tab: {
            fontSize: ThemeFontSizeToken.Large,
            lineHeight: '160%',
            height: '40px',
        },
    }),
    md: definePartsStyle({
        tab: {
            fontSize: ThemeFontSizeToken.XLarge,
            lineHeight: '125%',
            height: '48px',
        },
    }),
};
// Same color combination below is user for several pseudo selectors, use to avoid repetition
const interactiveStyle = {
    _disabled: {
        _selected: {
            bg: ThemeColorToken.AccentContainer,
            color: ThemeColorToken.OnAccentContainer,
        },
        bg: 'transparent',
        color: ThemeColorToken.OnBackground,
    },
    bg: ThemeColorToken.AccentContainer,
    color: ThemeColorToken.OnAccentContainer,
};
const variants = {
    default: definePartsStyle({
        tab: {
            '@media(hover: hover)': {
                _hover: interactiveStyle,
                _groupHover: interactiveStyle,
            },
            _selected: interactiveStyle,
            _disabled: { opacity: 0.48 },
        },
    }),
};
export const tabsConfig = defineMultiStyleConfig({
    sizes,
    variants,
    baseStyle,
});
//# sourceMappingURL=tabs-theme.js.map